// constants_roles.js
// Role constants for RBAC system (initial set)

export const ROLES = {
    SUPER_ADMIN: 'super_admin',
    WEBMASTER: 'webmaster',
    INSTITUTIONAL_OWNER: 'institutional_owner',
    TENANT_ADMIN: 'tenant_admin',
    SIMULATION_MANAGER: 'simulation_manager',

    INCIDENT_COMMANDER: 'incident_commander',
    OPERATIONS_CHIEF: 'operations_chief',
    LOGISTICS: 'logistics',
    SAFETY: 'safety',
    COMMUNICATIONS: 'communications',
    LIAISON: 'liaison',
    FINANCE_ADMIN: 'finance_admin',
    INTELLIGENCE_OFFICER: 'intelligence_officer',
    // Servicos Medicos — Fase 1 (fundacao backend, ver MANIFESTO-REACTAORION
    // Servicos Medicos). Coordenacao medico-assistencial da ocorrencia —
    // paralelo a Logistica/Ligacao, nao subordinado a nenhum dos dois. Nao
    // substitui autoridade clinica individual nem autoridade regulatoria
    // (SAMU/Central de Regulacao) — apenas coordena a situacao médica da
    // operacao dentro do SCI.
    MEDICAL_SERVICES: 'medical_services',

    OBSERVER: 'observer',
    PRESS: 'press',
    GUEST_AGENCY: 'guest_agency',

    // Hierarquia institucional Professor/Aluno (2026-08-05): Professor fica
    // abaixo de Institutional Owner, ao lado de Operador, mas com poder de
    // criar sala/gerir simulacao (que Operador nao tem) e de admitir Aluno.
    // Aluno fica abaixo de Operador/Professor, acima de Convidado. Ver
    // roomsRoutes.js, operationState.js, socketServer.js e
    // credentialRoutes.js para onde cada capacidade especifica e concedida
    // — deliberadamente NAO adicionados ao conjunto Tier-1 central em
    // roomsService.js (ver PLAN em Manifesto-E-auditorias-deve).
    PROFESSOR: 'professor',
    ALUNO: 'aluno',
};

export default ROLES;

// Roles that are allowed to perform an operational bootstrap (start runtime in STANDBY)
export const BOOTSTRAP_CAPABLE = [
    ROLES.WEBMASTER,
    ROLES.INSTITUTIONAL_OWNER,
    ROLES.SUPER_ADMIN,
    ROLES.SIMULATION_MANAGER
];

// Papeis funcionais SCI/ICS atribuiveis dinamicamente por operacao (Sprint A
// de Gestao Operacional de Participantes). Nao inclui papeis institucionais
// globais (webmaster/super_admin/institutional_owner/tenant_admin/
// simulation_manager), que permanecem fora do escopo da tabela
// operational_assignments.
export const SCI_FUNCTIONAL_ROLES = [
    ROLES.INCIDENT_COMMANDER,
    ROLES.OPERATIONS_CHIEF,
    ROLES.LOGISTICS,
    ROLES.SAFETY,
    ROLES.COMMUNICATIONS,
    ROLES.LIAISON,
    ROLES.FINANCE_ADMIN,
    ROLES.INTELLIGENCE_OFFICER,
    ROLES.MEDICAL_SERVICES,
];
